module.exports = __webpack_public_path__ + "static/img/logoBlue.44f7c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoBlue.png
// module id = a7zM
// module chunks = 3